import { MDBBtn, MDBCol, MDBContainer, MDBInputGroup, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Subscription.scss";

const Subscription = (props: SubscriptionProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary
    );

    return <section className="subscription">
        <MDBContainer>
            <MDBRow middle center>
                <MDBCol md="12" className="brand-image">
                    <h5>
                        {
                            dictionary?.offer?.subscribe_now
                        }
                    </h5>
                </MDBCol>

                <MDBCol md="5" sm="10" className="brand-image">
                    <MDBInputGroup
                        containerClassName="mb-3"
                        hint={dictionary?.share?.email}
                        append={
                            <MDBBtn
                                color="primary"
                                outline
                                className="m-0 px-3 py-2 z-depth-0"
                            >
                                {dictionary?.share?.subscription}
                            </MDBBtn>
                        }
                    />
                </MDBCol>

            </MDBRow>
        </MDBContainer>
    </section>
};

interface SubscriptionProps { }
export default Subscription;